export default function ({ store, $axios, redirect }) {
  $axios.onRequest((config) => {
    if (store.state.auth.activeMerchantId) {
      config.headers.common['merchant-id'] = store.state.auth.activeMerchantId;
    }
  });
  $axios.setHeader('Cache-Control', 'no-cache');
  if (process.env.VUE_APP_API_KEY && process.env.DEBUG) {
    $axios.setHeader('apiKey', process.env.VUE_APP_API_KEY);
    $axios.onError((error) => {
      const code = parseInt(error.response && error.response.status);
      if (code === 401 && process.env.VUE_APP_API_KEY && process.env.DEBUG) {
        redirect('/');
      }
    });
  }
}
